<template>
  <div class="clp">
    <article class="clp__hero">
      <header class="clp__header">
        <div class="componata-container">
          <div class="grid-2-middle">
            <div class="col">
              <h1 class="clp__header-logo"><a href="/" title="Homepage"><img src="@/assets/images/logo-w.svg" alt="Componata"></a></h1>
            </div>

            <!-- <div class="col">
              <p class="u-text-right">
                <i class="icon icon-phone"></i> 0341 9899 208
              </p>
            </div> -->
          </div>
        </div>
      </header>

      <div
        v-if="isContentLoaded"
        class="clp__hero-area"
      >
        <div class="componata-container">
          <div class="grid-2_sm-1">
            <div class="col">
              <h2 class="clp__hero-title">
                <small v-if="$store.getters.getCustomerLandingPageData.content.title_line_1">{{ $store.getters.getCustomerLandingPageData.content.title_line_1 }}</small>
                <br class="u-dp-none">
                {{ $store.getters.getCustomerLandingPageData.content.title_line_2 }}
              </h2>

              <ul
                v-if="$store.getters.getCustomerLandingPageData.content.info_area.type === 'bullets' && $store.getters.getCustomerLandingPageData.content.info_area.bullets.length > 0"
                class="clp__hero-bullets"
              >
                <li
                  v-for="(item, index) in $store.getters.getCustomerLandingPageData.content.info_area.bullets"
                  :key="index"
                >
                  <span>{{ item.businesslp_bullets_index }}</span>
                  <div v-html="item.businesslp_bullets_text"></div>
                </li>
              </ul>

              <div
                v-else-if="$store.getters.getCustomerLandingPageData.content.info_area.type == 'freetext' && $store.getters.getCustomerLandingPageData.content.info_area.freetext !== null"
                v-html="$store.getters.getCustomerLandingPageData.content.info_area.freetext"
                class="clp__hero-freetext"
              ></div>
            </div>

            <div class="col">
              <img
                v-if="isContentLoaded && $store.getters.getCustomerLandingPageData.content.image.length > 0"
                :src="$store.getters.getCustomerLandingPageData.content.image"
                class="clp__hero-image --is-custom"
                alt="Componata Präsente"
              >

              <img
                v-else
                src="@/assets/images/customer-landing-page-default@1x.png"
                srcset="@/assets/images/customer-landing-page-default@1x.png 1x, @/assets/images/customer-landing-page-default@2x.png 2x"
                class="clp__hero-image --is-default"
                alt="Componata Präsente"
              >
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="clp__hero-area --is-placeholder"
      >
        <div class="componata-container">
          <div class="grid-2_sm-1">
            <div class="col">
              <h2 class="clp__hero-title">
                <small></small>
                <span></span>
              </h2>

              <div class="clp__hero-freetext">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <div class="col">
              <img
                src="@/assets/images/customer-landing-page-default@1x.png"
                srcset="@/assets/images/customer-landing-page-default@1x.png 1x, @/assets/images/customer-landing-page-default@2x.png 2x"
                class="clp__hero-image --is-default"
                alt="Componata Präsente"
              >
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="isContentLoaded"
        class="clp__hero-footer"
      >
        <div class="componata-container">
          <slot v-if="$store.getters.getCustomerLandingPageData.login_button.is_visible">
            Already have an account? <Button type="href" :href="$store.getters.getCustomerLandingPageData.login_button.link" appearance="secondary">Click here</Button>
          </slot>
        </div>
      </div>
    </article>

    <Section id="products-section" class="products">
      <div class="componata-container --is-narrow">
        <SectionHeader>
          <template v-slot:title>
            <slot v-if="$store.getters.getCustomerLandingPageData.catalog_headline">
              {{ $store.getters.getCustomerLandingPageData.catalog_headline }}
            </slot>

            <slot v-else>
              Maßgeschneidertes Präsent für {{ $store.getters.getCustomerLandingPageData.title }}
            </slot>
          </template>

          <template v-slot:description>
            <p v-if="$store.getters.getCustomerLandingPageData.catalog_description" v-html="$store.getters.getCustomerLandingPageData.catalog_description"></p>

            <p v-else>Unsere Präsentboxen beinhalten ausschließlich ausgewählte Delikatessen aus aller Welt. Hochwertige und exklusive Feinkost für ganz besondere Menschen.</p>
          </template>
        </SectionHeader>
      </div>

      <div
        v-if="$store.getters.getCustomerLandingPageData.catalog_layout === 'simplified'"
        class="componata-container --is-narrow"
      >
        <ul
          v-if="isCatalogLoaded && $store.getters.getCustomerLandingPageCategories.length > 1"
          class="clp__catalog-nav"
        >
          <li>Filter: </li>
          <li
            @click="activeCategoryName = ''"
            :class="{ '--is-active' : activeCategoryName === '' }"
          >
            Alle Präsente
          </li>
          <li
            v-for="(category, index) in $store.getters.getCustomerLandingPageCategories"
            :key="index"
            @click="activeCategoryName = category"
            :class="{ '--is-active' : activeCategoryName === category }"
          >
            {{ category }}
          </li>
        </ul>

        <div
          v-if="isCatalogLoaded"
          class="grid-3_sm-2_xs-1-equalHeight"
        >
          <div
            v-for="(item, index) in catalog || 3"
            :key="index"
            class="col"
          >
            <PresentCard
              v-if="item.id"
              :isLoaded="true"
              :id="item.id"
              :item="item"
              :link="(item.cta.link ? item.cta.link : `/fertige/${item.id}`)"
              :price="item.show_price"
            />

            <PresentCard
              v-else
              :isLoaded="true"
              type="virtual"
              :id="item.id_virtual"
              :item="item"
              :link="(item.cta.link ? item.cta.link : `/zusammenstellen?__addLevel3s=${item.products.map(p => p.id).join(',')}`)"
              :price="item.show_price"
            />
          </div>
        </div>

        <div
          v-else
          class="grid-3_sm-2_xs-1-equalHeight"
        >
          <div
            v-for="index in 6"
            :key="index"
            class="col"
          >
            <PresentCard
              :isLoaded="false"
            />
          </div>
        </div>
      </div>

      <div
        v-else
        class="componata-container"
      >
        <PresentContents
          class="clp__present"
          v-for="(present, index) in catalog || 3"
          :key="index"
          :extended="true"
          :sku="present.sku"
          :type="present.type === 'level_1' ? 'level1' : 'level3'"
          :name="present.name"
          :pic="present.type === 'level_1' ? present.photos.b2c[0].original : null"
          :products="present.products"
        >
          <template v-slot:cta>
            <Button
              v-if="present.cta.link"
              :href="present.cta.link"
              appearance="primary"
            >{{ present.cta.text || 'zur Bestellung' }}</Button>

            <Button
              v-else-if="present.type === 'level_1'"
              type="router"
              :to="cLink(`/fertige/${present.id}`)"
              appearance="primary"
            >{{ present.cta.text || 'zur Bestellung' }}</Button>

            <Button
              v-else
              type="router"
              :to="cLink(`/zusammenstellen?__addLevel3s=${present.products.map(p => p.id).join(',')}`)"
              appearance="primary"
            >{{ present.cta.text || 'zur Bestellung' }}</Button>
          </template>

          <template
            v-if="present.show_price"
            v-slot:price
          >
            <Price
              v-if="present.type === 'level_1'"
              align="left"
            >
              <template v-slot:brutto>{{ getPriceForGroup(present, $store.getters.getUserGroupId, false) }}</template>
              <template v-slot:netto>{{ getPriceForGroup(present, $store.getters.getUserGroupId, true) }}</template>
            </Price>

            <Price
              v-else
              align="left"
            >
              <template v-slot:brutto>{{ humanPrice(present.products.reduce((v1, v2) => v1 + getPriceRawForGroup(v2, $store.getters.getUserGroupId, false), 0) + getPriceBoxRawForGroup($store.getters.getUserGroupId, false)) }}</template>
              <template v-slot:netto>{{ humanPrice(present.products.reduce((v1, v2) => v1 + getPriceRawForGroup(v2, $store.getters.getUserGroupId, true), 0) + splittedTaxSingleRaw(getPriceBoxRawForGroup($store.getters.getUserGroupId, false))) }}</template>
            </Price>
          </template>
        </PresentContents>
      </div>
    </Section>

    <Packaging
      v-if="isContentLoaded"
      :customFeatures="$store.getters.getCustomerLandingPageData.features"
    />

    <Faq
      v-if="isContentLoaded && $store.getters.getCustomerLandingPageData.faq.length > 0"
      :data="$store.getters.getCustomerLandingPageData.faq"
    />

    <TheFooter />
  </div>
</template>

<script>
import axios from 'axios';

import { logicMixin } from '@/mixins/LogicMixin';
import { LoaderMixin } from '@/mixins/LoaderMixin';

import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';
import PresentCard from '@/components/Common/PresentCard';
import PresentContents from '@/components/Pages/PresentContents';
import Button from '@/components/Common/Button';
import Price from '@/components/Common/Price';
import Packaging from '@/components/PresentPage/Packaging';
import Faq from '@/components/PresentPage/Faq';
import TheFooter from '@/components/TheFooter';

export default {
  name: 'CustomerLandingPage',
  mixins: [logicMixin, LoaderMixin],
  components: {
    Section,
    SectionHeader,
    PresentCard,
    PresentContents,
    Button,
    Price,
    Packaging,
    Faq,
    TheFooter
  },

  data: function () {
    return {
      isContentLoaded: false,
      isCatalogLoaded: false,
      data: null,
      categories: [],
      activeCategoryName: ''
    };
  },

  computed: {
    catalog () {
      if (this.$store.getters.getCustomerLandingPageCatalog) {
        return Object.values(this.$store.getters.getCustomerLandingPageCatalog).filter(item => {
          if (this.activeCategoryName === '' || item.virtual_category === this.activeCategoryName) {
            return true;
          }

          return false;
        });
      }

      return [];
    },
  },

  created () {
    this.$store.commit('setGlobalLoading', true);

    if (Object.keys(this.$store.getters.getCustomerLandingPageData).length > 0 && Object.keys(this.$store.getters.getCustomerLandingPageCatalog).length > 0) {
      this.isContentLoaded = true;
      this.isCatalogLoaded = true;
      this.$store.commit('setGlobalLoading', false);
    }

    // Get the data from the API
    axios
      .get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_business_lp/' + this.$route.params.id)
      .then((customerLpRes) => {
        if (customerLpRes.data) {
          this.$store.commit('setCustomerLandingPageData', customerLpRes.data);
          this.$store.commit('setUserGroupId', customerLpRes.data.customer_group_id.toString());
          axios
            .get(
              process.env.VUE_APP_BASE_URL +
                '/save_user_id.php?hard=1&given_group_id=' + customerLpRes.data.customer_group_id.toString()
            )
            .then(() => {});
          this.loadPostcards();

          const level1Presents = [];

          this.$store.getters.getCustomerLandingPageData.catalog.forEach(item => {
            if (item.id) {
              level1Presents.push(item.id);
            }
          });

          this.isContentLoaded = true;

          Promise.all([
            axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_level_1_fast?selectedId=' + level1Presents.join()),
            axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_level_3_fast'),
            axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_boxes')
          ])
            .then(([level1Res, level3Res, boxRes]) => {
              this.$store.commit('setListItemsLevel1', this.extendLvl1Req(level1Res.data));
              this.$store.commit('setListItemsLevel3', this.extendLvl3Req(level3Res.data));
              this.$store.commit('setBoxItemsLevel3', boxRes.data);
              this.$store.commit('setLevel3Box', boxRes.data[0]);

              // Create the custom and consolidate catalog of the customer, combining level 1 presents and virtual presents created out of level 3 products and create the categories array for the navigation
              const customerLandingPageCatalog = [];

              this.$store.getters.getCustomerLandingPageData.catalog.forEach(item => {
                // Level 1, else it is virtual
                if (item.id) {
                  customerLandingPageCatalog.push({
                    ...this.$store.getters.getListItemsLevel1Unfiltered.filter((present) => present.id === item.id)[0],
                    // labels: [item.virtual_category],
                    virtual_category: item.virtual_category,
                    cta: item.cta,
                    show_price: item.price
                  });
                } else {
                  // Virtual present
                  var products = [];

                  item.products.forEach(id => {
                    if (typeof this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[id]] !== 'undefined') {
                      products.push(this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[id]]);
                    }
                  });

                  customerLandingPageCatalog.push({
                    name: item.name,
                    virtual_category: item.virtual_category,
                    // labels: [item.virtual_category],
                    products: products,
                    cta: item.cta,
                    show_price: item.price
                  });
                }

                // Crate the categories
                if (!this.categories.includes(item.virtual_category)) {
                  this.categories.push(item.virtual_category);
                }
              });

              // Store the custom catalog and categories
              this.$store.commit('setCustomerLandingPageCatalog', customerLandingPageCatalog);
              this.$store.commit('setCustomerLandingPageCategories', this.categories);

              this.isCatalogLoaded = true;

              this.$store.commit('setLvl1Loaded', true);
              this.$store.commit('setGlobalLoading', false);
            });
        }
      })
      .catch(() => {
        this.$router.push(this.cLink('/404'));
      });
  },

  watch: {
    $route (to) {
      if (to.name === 'CustomerLandingPageDeliveryDetail') {
        this.$store.commit('setModalCustomOpen', true);
        this.$store.commit('setModalOpen', false);
      } else if (this.$route.name === 'CustomerLandingPageProductDetail') {
        this.$store.getters.getListItemsLevel3All.filter((level3Product) => {
          if (level3Product.id === Number(this.$route.params.productId)) {
            this.$store.commit('setModalItem', level3Product);
          }
        });
        this.$store.commit('setModalOpen', true);
        this.$store.commit('setModalCustomOpen', false);
      } else {
        this.$store.commit('setModalOpen', false);
        this.$store.commit('setModalCustomOpen', false);
      }
    },
  },

  metaInfo () {
    if (this.$store.getters.getCustomerLandingPageData) {
      return {
        title: this.$store.getters.getCustomerLandingPageData.title
      };
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * CustomerLandingPage
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present Page (Landing Page-style)
 * @since 2021-10-15
**/

$component: 'clp';

.#{$component} {
  background-color: $white;

  // Header
  &__header {
    @include padding(map-get($spacers, 6) 0);
  }

  &__header-logo {
    display: inline-block;
    width: 8rem;

    a,
    img {
      display: block;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  // Hero
  &__hero {
    overflow: hidden;
    background-color: $ink;
    color: $sky-lighter;
    background-image: url('~@/assets/images/bgr-tickling-stars.svg');
    background-size: fill;
    // background-position: -400% -15%;
    background-repeat: no-repeat;
  }

  &__hero-area {
    @include padding-bottom(map-get($spacers, 4));
  }

  &__hero-title {
    @include margin-bottom(map-get($spacers, 6));
    @include font-size($h1-font-size);
    font-family: $font-family-sans-serif-alt;
    font-weight: $font-weight-bolder;

    small {
      display: block;
      @include font-size($h3-font-size);
      font-weight: $font-weight-lighter;
    }
  }

  // Hero Content
  &__hero-bullets {
    @include unlist;

    > li {
      display: flex;
      align-items: flex-start;
      margin: 0;
      padding: 0;

      &:not(:last-child) {
        @include margin-bottom(map-get($spacers, 4));
      }

      > span {
        display: flex;
        @include rfs(1.8rem, width);
        align-items: center;
        justify-content: center;
        aspect-ratio: 1 / 1;
        @include margin-right(map-get($spacers, 3));
        border-radius: 50%;
        background-color: $yellow;
        color: $ink;
        @include font-size($font-size-lg);
        font-weight: $font-weight-bolder;
      }

      ::v-deep > div {
        p {
          @include margin(0 0 map-get($spacers, 0) 0);
          color: $sky-dark;

          a {
            color: $yellow;
            text-decoration: none;
          }

          &:first-child {
            color: $sky-lighter;
            @include font-size($font-size-lg);

            strong,
            b {
              font-weight: $font-weight-bold;
            }
          }
        }
      }
    }
  }

  &__hero-image {
    display: block;

    &.--is-default {
      width: 140%;
      margin-top: -45%;
      margin-bottom: -45%;
      margin-left: -10%;
    }

    &.--is-custom {
      width: 90%;
      margin-top: -10%;
      margin-bottom: -20%;
      margin-left: 10%;
    }
  }

  &__hero-freetext {
    @include font-size($font-size-lg);
    font-weight: $font-weight-light;

    ::v-deep {
      a {
        color: $yellow;
        text-decoration: none;

        @include hover () {
          color: darken($yellow, 25%);
        }
      }
    }
  }

  &__hero-footer {
    @include padding(map-get($spacers, 5) 0);
    background: linear-gradient(180deg, darken($ink, 3%) 0%, transparent 100%);
  }

  // Section hack for allowing media
  ::v-deep .section-header__description {
    .wp-video {
      width: 100%;
      height: auto;
      margin: 0 auto;
    }
  }

  // Catalog
  &__catalog-nav {
    @include unlist;
    position: sticky;
    top: 0;
    z-index: 4;
    display: flex;
    @include margin-bottom(map-get($spacers, 4));
    @include padding(map-get($spacers, 3) 0);
    // border-bottom: 1px solid $gray-ghost-fixed;
    // box-shadow: 0 10px 9px -10px rgba($ink, 0.1);
    background-color: $white;

    &:-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }

    > li {
      flex-shrink: 0;
      @include padding-bottom(map-get($spacers, 1));
      border-bottom: 4px solid transparent;
      color: $ink-lighter;
      @include font-size($font-size-lg);

      &:not(:last-child) {
        @include margin-right(map-get($spacers, 5));
      }

      &:first-child {
        @include margin-right(map-get($spacers, 3));
      }

      &:not(:first-child) {
        cursor: pointer;

        @include hover () {
          border-bottom-color: $sky;
        }
      }

      &.--is-active {
        border-bottom-color: $yellow;
        font-weight: $font-weight-bolder;
      }
    }
  }

  // Placehoder
  .--is-placeholder {
    @include placeholder();

    .#{$component} {
      &__hero-title {
        small,
        span {
          display: block;
        }

        small {
          width: 40%;
          height: $h3-font-size;
          @include margin-bottom(map-get($spacers, 3));
          background-color: $ink-lightest;
        }

        span {
          width: 70%;
          height: $h1-font-size;
          background-color: $sky;
        }
      }

      &__hero-freetext {
        span {
          display: block;
          height: $font-size-lg;
          @include margin-bottom(map-get($spacers, 2));
          background-color: $ink-lighter;

          &:first-child {
            width: 50%;
          }

          &:nth-child(2n) {
            width: 60%;
          }

          &:nth-child(3n) {
            width: 70%;
          }

          &:nth-child(4n) {
            width: 40%;
          }
        }
      }
    }
  }

  &__present + &__present {
    @include margin-top(map-get($spacers, 6));
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
    &__hero-image {
      &.--is-default {
        width: 130%;
        margin-top: -40%;
      }
    }
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__hero-image {
      &.--is-default {
        width: 160%;
        margin-top: -40%;
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__hero-image {
      display: none;
    }

    &__catalog-nav {
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;

      > li {
        &:not(:last-child) {
          @include margin-right(map-get($spacers, 3));
        }
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {

  }
}
</style>
